import BaseManager from "@base/baseManager.js";
import api from "@api/api.js";
import ShowcaseObject from "./showcaseObject.js";

/**
 * Gear item data: fetches the gear pile overview from the backend and stores
 * ShowcaseObjects, ordered as returned (backend sorts by `order`).
 * Also tracks whether the current user is an admin (returned by the overview).
 */
export default class ShowcaseManager extends BaseManager {
  constructor() {
    super("gearItemId");
    this.admin = false;
  }

  async load() {
    const overview = await api.get("/api/showcase");
    this.admin = Boolean(overview?.admin);
    this.set((overview?.items || []).map((i) => new ShowcaseObject(i)));
    return this.all();
  }
}
